require('./bootstrap');

import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'

locale.use(lang)

ElementUI.Select.computed.readonly = function () {
    const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
    return !(this.filterable || this.multiple || !isIE) && !this.visible;
};

export default ElementUI;

Vue.use(ElementUI, { size: 'small' })
Vue.prototype.$eventHub = new Vue()

Vue.component('tenant-item-aditional-info-selector', require('./views/tenant/components/partials/item_extra_info').default);
Vue.component('tenant-item-aditional-info-modal', require('./views/tenant/components/partials/modal_item_info_attributes').default);



Vue.component('x-graph', require('./components/graph/src/Graph').default);
// Vue.component('x-graph-line', require('./components/graph/src/GraphLine').default);

// configuracion pse
Vue.component('tenant-certificates-index', require('./views/tenant/certificates/index').default);
Vue.component('tenant-certificates-form', require('./views/tenant/certificates/form').default);
Vue.component('tenant-configurations-form', require('./views/tenant/configurations/form').default);
Vue.component('tenant-configurations-form-purchases', require('./views/tenant/configurations/partials/purchases').default);
Vue.component('tenant-configurations-visual', require('./views/tenant/configurations/visual').default);
Vue.component('tenant-configurations-pdf', require('./views/tenant/configurations/pdf_templates').default);
Vue.component('tenant-configurations-ticket-pdf', require('./views/tenant/configurations/pdf_ticket_templates').default);
Vue.component('tenant-configurations-sale-notes', require('./views/tenant/configurations/sale_notes').default);
Vue.component('tenant-configurations-pdf-guide', require('./views/tenant/configurations/pdf_guide_templates').default);
Vue.component('tenant-configurations-preprinted-pdf', require('./views/tenant/configurations/pdf_preprinted_templates').default);
Vue.component('tenant-dialog-header-menu', require('./views/tenant/configurations/partials/dialog_header_menu').default);
// Vue.component('tenant-establishments-form', require('./views/tenant/establishments/form'));
// Vue.component('tenant-series-form', require('./views/tenant/series/form'));
Vue.component('tenant-bank_accounts-index', require('./views/tenant/bank_accounts/index').default);
Vue.component('tenant-items-index', require('./views/tenant/items/index').default);
Vue.component('tenant-persons-index', require('./views/tenant/persons/index').default);
// Vue.component('tenant-customers-index', require('./views/tenant/customers/index').default);
 Vue.component('tenant-person-form', require('./views/tenant/persons/form').default);

// Vue.component('tenant-suppliers-index', require('./views/tenant/suppliers/index').default);

// Vue.component('tenant-users-form', require('./views/tenant/users/form').default);

// purchase-settlements

Vue.component('tenant-summaries-index', require('./views/tenant/summaries/index').default);
Vue.component('tenant-voided-index', require('./views/tenant/voided/index').default);
Vue.component('tenant-search-index', require('./views/tenant/search/index').default);
Vue.component('tenant-options-form', require('./views/tenant/options/form').default);
Vue.component('tenant-unit_types-index', require('./views/tenant/unit_types/index').default);
Vue.component('tenant-detraction_types-index', require('./views/tenant/detraction_types/index').default);
Vue.component('tenant-establishments-index', require('./views/tenant/establishments/index').default);
Vue.component('tenant-charge_discounts-index', require('./views/tenant/charge_discounts/index').default);
Vue.component('tenant-banks-index', require('./views/tenant/banks/index').default);
Vue.component('tenant-exchange_rates-index', require('./views/tenant/exchange_rates/index').default);
Vue.component('tenant-currency-types-index', require('./views/tenant/currency_types/index').default);
Vue.component('tenant-perceptions-index', require('./views/tenant/perceptions/index').default);
Vue.component('tenant-perceptions-form', require('./views/tenant/perceptions/form').default);




Vue.component('tenant-purchases-items', require('./views/tenant/dispatches/items').default);


Vue.component('tenant-guides-modal', require('./views/tenant/components/guides').default);

Vue.component('tenant-transfer-reason-types-index', require('./views/tenant/transfer_reason_types/index').default);


Vue.component('tenant-attribute_types-index', require('./views/tenant/attribute_types/index').default);
Vue.component('tenant-calendar', require('./views/tenant/components/calendar').default);
Vue.component('tenant-warehouses', require('./views/tenant/components/warehouses').default);
Vue.component('tenant-calendar-quotation', require('./views/tenant/components/calendarquotations').default);

Vue.component('tenant-product', require('./views/tenant/components/products').default);


Vue.component('tenant-tasks-index', require('./views/tenant/Tasks/Index').default);
Vue.component('tenant-tasks-form', require('./views/tenant/Tasks/Form').default);
Vue.component('tenant-reports-consistency-documents-lists', require('./views/tenant/reports/consistency-documents/lists').default);


Vue.component('tenant-sale-notes-index', require('./views/tenant/SaleNotes/Index').default);
Vue.component('tenant-sale-notes-form', require('./views/tenant/SaleNotes/Form').default);

Vue.component('cash-index', require('./views/tenant/cash/index').default);
Vue.component('tenant-card-brands-index', require('./views/tenant/card_brands/index').default);



Vue.component('tenant-categories-index', require('./views/tenant/items/categories/index').default);
Vue.component('tenant-brands-index', require('./views/tenant/items/brands/index').default);
Vue.component('tenant-zone-index', require('./views/tenant/items/zone/index').default);
Vue.component('tenant-incentives-index', require('./views/tenant/items/incentives/index').default);
Vue.component('tenant-item-lots-index', require('./views/tenant/items/item-lots/index').default);
Vue.component('tenant-web-platforms-index', require('./views/tenant/items/web-platforms/index').default);


//Sale
Vue.component('tenant-sale-opportunities-index', require('./views/tenant/SaleOpportunities/index').default);
Vue.component('tenant-sale-opportunities-form', require('./views/tenant/SaleOpportunities/form').default);
Vue.component('tenant-production-orders-index', require('./views/tenant/Sale/production_orders/index').default);
Vue.component('tenant-agents-index', require('./views/tenant/Sale/agents/index').default);
Vue.component('tenant-technical-services-index', require('./views/tenant/Sale/technical-services/index').default);
Vue.component('tenant-user-commissions-index', require('./views/tenant/Sale/user-commissions/index').default);


Vue.component('tenant-contracts-index', require('./views/tenant/Contracts/index').default);
Vue.component('tenant-contracts-form', require('./views/tenant/Contracts/form').default);

//Item

Vue.component('x-input-service', require('./views/tenant/ApiPeruDev/components/InputService').default); // apiperu - porque cambiar el input si tiene el mismo contenido?
Vue.component('tenant-tags-index', require('./views/tenant/tags/index').default);
Vue.component('tenant-promotions-index', require('./views/tenant/promotions/index').default);
Vue.component('tenant-item-sets-index', require('./views/tenant/item_sets/index').default);
Vue.component('tenant-person-types-index', require('./views/tenant/person_types/index').default);

//Cuenta
Vue.component('tenant-account-payment-index', require('./views/tenant/account/payment_index').default);
Vue.component('tenant-account-configuration-index', require('./views/tenant/account/configuration').default);

// Configuración del login
Vue.component('tenant-login-page', require('./views/tenant/login/index').default);
Vue.component('data-table-payment-receipt', require('../js/components/DataTablePaymentReceipt').default);

// MobileApp ::
Vue.component('tenant-mobile-app-configuration', require('./views/tenant/MobileApp/configuration/index').default);
Vue.component('tenant-mobile-app-permissions', require('./views/tenant/MobileApp/permissions/index').default);

// LevelAccess
Vue.component('tenant-system-activity-logs-generals-index', require('./views/tenant/LevelAccess/system_activity_logs/generals/index').default);
Vue.component('tenant-system-activity-logs-transactions-index', require('./views/tenant/LevelAccess/system_activity_logs/transactions/index').default);
Vue.component('tenant-remember-change-password', require('./views/tenant/users/partials/remember_change_password').default);

// Reportes en system
Vue.component('system-report-login-lockout-index', require('./views/tenant/Report/system/report_login_lockout/index').default);
Vue.component('system-user-not-change-password-index', require('./views/tenant/Report/system/user_not_change_password/index').default);

// Notifications
Vue.component('tenant-notification-certificate-due', require('./views/tenant/Notifications/Form').default);

//System
require('./system');

//Tenant
require('./tenant');

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import moment from 'moment';
Vue.mixin({
    filters: {
        toDecimals(number, decimal = 2) {
            return Number(number).toFixed(decimal);
        },
        DecimalText: function (number, decimal = 2) {
            return isNaN(parseFloat(number)) ? number : Number(number).toFixed(decimal);
        },
        toDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY');
            }
            return '';
        },
        toTime(time) {
            if (time) {
                if (time.length === 5) {
                    return moment(time + ':00', 'HH:mm:ss').format('HH:mm:ss');
                }
                return moment(time, 'HH:mm:ss').format('HH:mm:ss');
            }
            return '';
        },
        pad(value, fill = '', length = 3) {
            if (value) {
                return String(value).padStart(length, fill);
            }
            return value;
        }
    },
    methods: {
        axiosError(error) {
            const response = error.response;
            const status = response.status;
            if (status === 422) {
                this.errors = response.data
            }
            if (status === 500) {
                this.$message({
                    type: 'info',
                    message: response.data.message
                  });
            }
        },
        getResponseValidations(success = true, message = null)
        {
            return {
                success: success,
                message: message
            }
        }
    }
})
const app = new Vue({
    store: store,
    el: '#main-wrapper'
});
